import { render, staticRenderFns } from "./StaffAndPayrollTable.vue?vue&type=template&id=1ef3d91e&scoped=true"
import script from "./StaffAndPayrollTable.vue?vue&type=script&lang=js"
export * from "./StaffAndPayrollTable.vue?vue&type=script&lang=js"
import style0 from "./StaffAndPayrollTable.vue?vue&type=style&index=0&id=1ef3d91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3d91e",
  null
  
)

export default component.exports